// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: #e0e0e0;
    font-family: 'Press Start 2P', cursive;
    color: #000;
    margin: 0;
    padding: 0;
}

h1, h2, h3, h4, h5, h6 {
    color: var(--gb-lightest);
    margin-bottom: 20px;
    text-shadow: 2px 2px 0 var(--gb-darkest);
}

h2 {
    font-size: 20px;
    border-bottom: 4px solid var(--gb-darkest);
    padding-bottom: 10px;
    display: inline-block;
}

h3 {
    font-size: 14px;
    color: var(--gb-accent);
    margin-bottom: 10px;
}

p {
    color: var(--gb-lightest);
    margin-bottom: 15px;
    line-height: 1.8;
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: break-word;
}

section {
    background-color: var(--gb-light);
    border: 6px solid var(--gb-darkest);
    padding: 30px;
    margin: 20px;
    position: relative;
}

section::before {
    content: '';
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    bottom: 10px;
    border: 2px dashed var(--gb-darkest);
    pointer-events: none;
}

ul {
    list-style: none;
    margin: 20px 0;
}

ul li {
    background-color: var(--gb-dark);
    color: var(--gb-lightest);
    padding: 15px;
    margin-bottom: 10px;
    border: 3px solid var(--gb-darkest);
    position: relative;
    padding-left: 30px;
    transition: all 0.3s ease;
}

ul li::before {
    position: absolute;
    left: 10px;
    color: var(--gb-accent);
    transition: all 0.3s ease;
}

ul li:hover {
    background-color: var(--gb-accent);
    color: var(--gb-darkest);
    transform: translateX(5px);
    box-shadow: 4px 4px 0 rgba(0, 0, 0, 0.3);
}

ul li:hover::before {
    color: var(--gb-darkest);
    transform: translateX(3px);
}

/* Grid de habilidades en dos columnas */
.skills-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin-bottom: 20px;
}

.skills-grid li:hover {
    background-color: var(--gb-dark);
    color: var(--gb-lightest);
    transform: translateX(5px);
    box-shadow: 4px 4px 0 rgba(0, 0, 0, 0.3);
}

.skills-grid li:hover::before {
    color: var(--gb-lightest);
    transform: translateX(3px);
}

/* Eliminar flecha de los items del LogoLoop */
.tech-logos-container ul li {
    padding-left: 15px;
    background-color: transparent;
    border: none;
    margin-bottom: 0;
}

.tech-logos-container ul li::before {
    content: none;
}

.tech-logos-container ul li:hover {
    background-color: transparent;
    transform: none;
    box-shadow: none;
}

/* Redes sociales */
.social-links {
    display: flex;
    gap: 15px;
    justify-content: center;
    margin: 20px 0;
}

.social-links li {
    background-color: var(--gb-darkest);
    padding: 15px 20px;
    padding-left: 15px;
    flex: 0 1 auto;
}

.social-links li::before {
    content: none;
}

.social-links li a {
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--gb-lightest);
    text-decoration: none;
    border: none;
}

.social-links li a img {
    width: 32px;
    height: 32px;
    filter: brightness(0) invert(1);
    image-rendering: auto;
    transition: all 0.3s ease;
}

.social-links li:hover {
    background-color: var(--gb-accent);
    transform: translateY(-5px);
}

.social-links li:hover a {
    color: var(--gb-darkest);
}

.social-links li:hover a img {
    filter: brightness(0);
    transform: scale(1.1);
}

a {
    color: var(--gb-accent);
    text-decoration: none;
    border-bottom: 2px dotted var(--gb-accent);
    transition: all 0.3s;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

a:hover {
    color: var(--gb-lightest);
    border-bottom-color: var(--gb-lightest);
}

button, input[type="submit"] {
    background-color: var(--gb-darkest);
    color: var(--gb-lightest);
    border: 4px solid var(--gb-dark);
    padding: 12px 24px;
    cursor: pointer;
    font-family: 'Press Start 2P', cursive;
    font-size: 12px;
    transition: all 0.3s;
    margin-top: 10px;
}

button:hover, input[type="submit"]:hover {
    background-color: var(--gb-accent);
    color: var(--gb-darkest);
    border-color: var(--gb-lightest);
    transform: scale(1.05);
}

button:active, input[type="submit"]:active {
    transform: scale(0.95);
}

button:disabled, input[type="submit"]:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
}

button:disabled:hover, input[type="submit"]:disabled:hover {
    background-color: var(--gb-darkest);
    color: var(--gb-lightest);
    border-color: var(--gb-dark);
}

/* Formularios */
.form-group {
    margin-bottom: 20px;
}

label {
    display: block;
    color: var(--gb-lightest);
    margin-bottom: 8px;
}

input[type="text"],
input[type="email"],
textarea {
    width: 100%;
    background-color: var(--gb-darkest);
    color: var(--gb-accent);
    border: 3px solid var(--gb-dark);
    padding: 12px;
    font-family: 'Press Start 2P', cursive;
    font-size: 10px;
}

input:focus,
textarea:focus {
    outline: none;
    border-color: var(--gb-accent);
    box-shadow: 0 0 10px var(--gb-accent);
}

input:disabled,
textarea:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

textarea {
    min-height: 120px;
    resize: vertical;
}

/* Mensaje de estado del formulario */
.submit-message {
    padding: 15px;
    margin: 15px 0;
    border: 3px solid;
    font-size: 10px;
    line-height: 1.6;
}

.submit-message--success {
    background-color: var(--gb-accent);
    color: var(--gb-darkest);
    border-color: var(--gb-darkest);
}

.submit-message--error {
    background-color: #d32f2f;
    color: var(--gb-lightest);
    border-color: var(--gb-darkest);
}

/* Experiencia y Proyectos */
.experience ul li,
.projects ul li {
    background-color: var(--gb-dark);
    margin-bottom: 20px;
    padding: 20px;
}

strong {
    color: var(--gb-accent);
}

/* Contenedor de logos tecnológicos */
.tech-logos-container {
    margin: 10px 0 20px;
    padding: 15px 0;
    background-color: var(--gb-light);
    border: 0px solid var(--gb-darkest);
    overflow: hidden;
    width: 100%;
    max-width: 100%;
    position: relative;
}

/* Estilos personalizados para LogoLoop */
.tech-logos-container .logoloop__item img {
    filter: grayscale(20%);
    transition: all 0.3s ease;
    image-rendering: auto;
}

.tech-logos-container .logoloop__item:hover img {
    filter: grayscale(0%);
    transform: scale(1.1);
}

/* Responsive */
@media (max-width: 768px) {
    section {
        margin: 10px;
        padding: 20px;
    }
    
    nav ul {
        width: 100%;
    }
    
    h2 {
        font-size: 16px;
    }
    
    .skills-grid {
        grid-template-columns: 1fr;
    }
    
    .tech-logos-container {
        padding: 10px 0;
        margin: 5px 0 15px;
    }
    
    .social-links {
        flex-direction: column;
        align-items: center;
    }
    
    .social-links li {
        width: 100%;
        max-width: 250px;
    }
    
    .social-links li a {
        justify-content: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/components.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,sCAAsC;IACtC,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,0CAA0C;IAC1C,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,mCAAmC;IACnC,aAAa;IACb,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,mCAAmC;IACnC,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,wBAAwB;IACxB,0BAA0B;IAC1B,wCAAwC;AAC5C;;AAEA;IACI,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA,wCAAwC;AACxC;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,0BAA0B;IAC1B,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA,8CAA8C;AAC9C;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,0CAA0C;IAC1C,oBAAoB;IACpB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;AAC3C;;AAEA;IACI,mCAAmC;IACnC,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,eAAe;IACf,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mCAAmC;IACnC,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA,gBAAgB;AAChB;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;;;IAGI,WAAW;IACX,mCAAmC;IACnC,uBAAuB;IACvB,gCAAgC;IAChC,aAAa;IACb,sCAAsC;IACtC,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,8BAA8B;IAC9B,qCAAqC;AACzC;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,wBAAwB;IACxB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA,4BAA4B;AAC5B;;IAEI,gCAAgC;IAChC,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,qCAAqC;AACrC;IACI,mBAAmB;IACnB,eAAe;IACf,iCAAiC;IACjC,mCAAmC;IACnC,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA,yCAAyC;AACzC;IACI,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA,eAAe;AACf;IACI;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;AACJ","sourcesContent":["body {\n    background-color: #e0e0e0;\n    font-family: 'Press Start 2P', cursive;\n    color: #000;\n    margin: 0;\n    padding: 0;\n}\n\nh1, h2, h3, h4, h5, h6 {\n    color: var(--gb-lightest);\n    margin-bottom: 20px;\n    text-shadow: 2px 2px 0 var(--gb-darkest);\n}\n\nh2 {\n    font-size: 20px;\n    border-bottom: 4px solid var(--gb-darkest);\n    padding-bottom: 10px;\n    display: inline-block;\n}\n\nh3 {\n    font-size: 14px;\n    color: var(--gb-accent);\n    margin-bottom: 10px;\n}\n\np {\n    color: var(--gb-lightest);\n    margin-bottom: 15px;\n    line-height: 1.8;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n    word-break: break-word;\n}\n\nsection {\n    background-color: var(--gb-light);\n    border: 6px solid var(--gb-darkest);\n    padding: 30px;\n    margin: 20px;\n    position: relative;\n}\n\nsection::before {\n    content: '';\n    position: absolute;\n    top: 10px;\n    left: 10px;\n    right: 10px;\n    bottom: 10px;\n    border: 2px dashed var(--gb-darkest);\n    pointer-events: none;\n}\n\nul {\n    list-style: none;\n    margin: 20px 0;\n}\n\nul li {\n    background-color: var(--gb-dark);\n    color: var(--gb-lightest);\n    padding: 15px;\n    margin-bottom: 10px;\n    border: 3px solid var(--gb-darkest);\n    position: relative;\n    padding-left: 30px;\n    transition: all 0.3s ease;\n}\n\nul li::before {\n    position: absolute;\n    left: 10px;\n    color: var(--gb-accent);\n    transition: all 0.3s ease;\n}\n\nul li:hover {\n    background-color: var(--gb-accent);\n    color: var(--gb-darkest);\n    transform: translateX(5px);\n    box-shadow: 4px 4px 0 rgba(0, 0, 0, 0.3);\n}\n\nul li:hover::before {\n    color: var(--gb-darkest);\n    transform: translateX(3px);\n}\n\n/* Grid de habilidades en dos columnas */\n.skills-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n    margin-bottom: 20px;\n}\n\n.skills-grid li:hover {\n    background-color: var(--gb-dark);\n    color: var(--gb-lightest);\n    transform: translateX(5px);\n    box-shadow: 4px 4px 0 rgba(0, 0, 0, 0.3);\n}\n\n.skills-grid li:hover::before {\n    color: var(--gb-lightest);\n    transform: translateX(3px);\n}\n\n/* Eliminar flecha de los items del LogoLoop */\n.tech-logos-container ul li {\n    padding-left: 15px;\n    background-color: transparent;\n    border: none;\n    margin-bottom: 0;\n}\n\n.tech-logos-container ul li::before {\n    content: none;\n}\n\n.tech-logos-container ul li:hover {\n    background-color: transparent;\n    transform: none;\n    box-shadow: none;\n}\n\n/* Redes sociales */\n.social-links {\n    display: flex;\n    gap: 15px;\n    justify-content: center;\n    margin: 20px 0;\n}\n\n.social-links li {\n    background-color: var(--gb-darkest);\n    padding: 15px 20px;\n    padding-left: 15px;\n    flex: 0 1 auto;\n}\n\n.social-links li::before {\n    content: none;\n}\n\n.social-links li a {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: var(--gb-lightest);\n    text-decoration: none;\n    border: none;\n}\n\n.social-links li a img {\n    width: 32px;\n    height: 32px;\n    filter: brightness(0) invert(1);\n    image-rendering: auto;\n    transition: all 0.3s ease;\n}\n\n.social-links li:hover {\n    background-color: var(--gb-accent);\n    transform: translateY(-5px);\n}\n\n.social-links li:hover a {\n    color: var(--gb-darkest);\n}\n\n.social-links li:hover a img {\n    filter: brightness(0);\n    transform: scale(1.1);\n}\n\na {\n    color: var(--gb-accent);\n    text-decoration: none;\n    border-bottom: 2px dotted var(--gb-accent);\n    transition: all 0.3s;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n}\n\na:hover {\n    color: var(--gb-lightest);\n    border-bottom-color: var(--gb-lightest);\n}\n\nbutton, input[type=\"submit\"] {\n    background-color: var(--gb-darkest);\n    color: var(--gb-lightest);\n    border: 4px solid var(--gb-dark);\n    padding: 12px 24px;\n    cursor: pointer;\n    font-family: 'Press Start 2P', cursive;\n    font-size: 12px;\n    transition: all 0.3s;\n    margin-top: 10px;\n}\n\nbutton:hover, input[type=\"submit\"]:hover {\n    background-color: var(--gb-accent);\n    color: var(--gb-darkest);\n    border-color: var(--gb-lightest);\n    transform: scale(1.05);\n}\n\nbutton:active, input[type=\"submit\"]:active {\n    transform: scale(0.95);\n}\n\nbutton:disabled, input[type=\"submit\"]:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    transform: none;\n}\n\nbutton:disabled:hover, input[type=\"submit\"]:disabled:hover {\n    background-color: var(--gb-darkest);\n    color: var(--gb-lightest);\n    border-color: var(--gb-dark);\n}\n\n/* Formularios */\n.form-group {\n    margin-bottom: 20px;\n}\n\nlabel {\n    display: block;\n    color: var(--gb-lightest);\n    margin-bottom: 8px;\n}\n\ninput[type=\"text\"],\ninput[type=\"email\"],\ntextarea {\n    width: 100%;\n    background-color: var(--gb-darkest);\n    color: var(--gb-accent);\n    border: 3px solid var(--gb-dark);\n    padding: 12px;\n    font-family: 'Press Start 2P', cursive;\n    font-size: 10px;\n}\n\ninput:focus,\ntextarea:focus {\n    outline: none;\n    border-color: var(--gb-accent);\n    box-shadow: 0 0 10px var(--gb-accent);\n}\n\ninput:disabled,\ntextarea:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\ntextarea {\n    min-height: 120px;\n    resize: vertical;\n}\n\n/* Mensaje de estado del formulario */\n.submit-message {\n    padding: 15px;\n    margin: 15px 0;\n    border: 3px solid;\n    font-size: 10px;\n    line-height: 1.6;\n}\n\n.submit-message--success {\n    background-color: var(--gb-accent);\n    color: var(--gb-darkest);\n    border-color: var(--gb-darkest);\n}\n\n.submit-message--error {\n    background-color: #d32f2f;\n    color: var(--gb-lightest);\n    border-color: var(--gb-darkest);\n}\n\n/* Experiencia y Proyectos */\n.experience ul li,\n.projects ul li {\n    background-color: var(--gb-dark);\n    margin-bottom: 20px;\n    padding: 20px;\n}\n\nstrong {\n    color: var(--gb-accent);\n}\n\n/* Contenedor de logos tecnológicos */\n.tech-logos-container {\n    margin: 10px 0 20px;\n    padding: 15px 0;\n    background-color: var(--gb-light);\n    border: 0px solid var(--gb-darkest);\n    overflow: hidden;\n    width: 100%;\n    max-width: 100%;\n    position: relative;\n}\n\n/* Estilos personalizados para LogoLoop */\n.tech-logos-container .logoloop__item img {\n    filter: grayscale(20%);\n    transition: all 0.3s ease;\n    image-rendering: auto;\n}\n\n.tech-logos-container .logoloop__item:hover img {\n    filter: grayscale(0%);\n    transform: scale(1.1);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    section {\n        margin: 10px;\n        padding: 20px;\n    }\n    \n    nav ul {\n        width: 100%;\n    }\n    \n    h2 {\n        font-size: 16px;\n    }\n    \n    .skills-grid {\n        grid-template-columns: 1fr;\n    }\n    \n    .tech-logos-container {\n        padding: 10px 0;\n        margin: 5px 0 15px;\n    }\n    \n    .social-links {\n        flex-direction: column;\n        align-items: center;\n    }\n    \n    .social-links li {\n        width: 100%;\n        max-width: 250px;\n    }\n    \n    .social-links li a {\n        justify-content: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
